const DEBUG = false; // use this as a conditional for console logging

var $pdpBreakOne = 800;


// issues with deliveries to Ireland (Eire) and Northern Ireland open modal on checkout address lookup
$(document).on("change", "#shipping-address-search", function ($e) {
	let $value = $e.target.value;
	// console.log($value)
	if ($value.substring(0,2).toLowerCase().includes('bt')) {
		// show modal
		openOverlay("countryPopUp");
	}
});


function adviceModal() {
	if ($(window).width() > 800) {
		var modalTrigger = $("[data-js-advice-modal-trigger]");
		if ($(modalTrigger)[0]) {
			$(modalTrigger).on("click", function () {
				var modal = $(this).closest(".advice-listing__item").find("[data-js-advice-modal]");
				if ($(modal)[0]) {
					if ($(modal).hasClass("active")) {
						$(modal).removeClass("active")
					} else {
						$(modal).addClass("active")
					}
				}
			});
		}
	}
}
adviceModal();

function hotspots() {
	if ($(".js-hotspot-toggle")[0]) {
		$(".js-hotspot-toggle").on("click", function () {
			$(this).closest(".hotspots").toggleClass("active")
			$(this).closest(".hotspots").find(".js-hotspot-item").removeClass("active")
		});

		$(".js-hotspot-item").on("click", function () {
			$(this).addClass("active")
			$(this).siblings().removeClass("active")
		});

		$(".js-hotspot-close").on("click", function () {
			$(this).siblings().removeClass("active")
		});
	}
}
hotspots();

function pdpBuilder() {
	// Show the default base tile
	$('.pdp-builder-base-tiles .product-card:first').addClass('active');
	// Remove value from options[Colour Combination] line item
	$('input[name="options[Colour Combination]"]').attr('value', '');

	if ($(".js-pdp-builder")[0]) {
		// ********************
		// base tile option button click
		// ********************

		$(".js-builder-base-tile-button").on("click", function () {
			// Add 'selected' style to active choice
			$(this).closest('ul').children('li').removeClass('pdp-builder__item--selected');
			$(this).closest('li').addClass('pdp-builder__item--selected');

			// Set the base tile background on the result image
			var baseTileImage = $(this).find('.pdp-builder__item-image').attr('src');
			$('.js-result-base-tile').css("background-image", "url("+ baseTileImage +")"); 

			// Show / hide the related base tile product card
			var baseTileID = "#product__" + $(this).attr('data-builder-base-tile-id');
			$('.pdp-builder-base-tiles .product-card').removeClass('active')
			$(baseTileID).addClass('active');

			// Update the base tile line item option & selection text
			var baseTileTitle = $(this).find('.pdp-builder__item-title').text();
			$('.js-builder-line-item-base').attr('value', baseTileTitle)
			$('js-builder-selection-base').text(baseTileTitle)

			// Get base tile slug from clicked button
			var baseTileSlug = $(this).attr('data-builder-base-tile-slug');

			// Amend img src of result graphic to contain the new bg tile
			var builderGraphic = $('.js-result-graphic').find('img');
			var graphicSplit0 = builderGraphic.attr('src').split('__')[0];
			var graphicSplit1 = builderGraphic.attr('src').split('__')[1];
			builderGraphic.attr('src', graphicSplit0 + '__' + graphicSplit1 + '__' + baseTileSlug + '.jpg' )

			$("[data-slider='pdp-slider']").slick("slickGoTo", 0);
		});


		// ********************
		// colour option button click
		// ********************
		$(".js-builder-colour-button").on("click", function () {
			// Add 'selected' style to active choice
			$(this).closest('ul').children('li').removeClass('pdp-builder__item--selected');
			$(this).closest('li').addClass('pdp-builder__item--selected');

			// Get colour slug from clicked button
			var builderColour = $(this).attr('data-builder-colour-slug');
			var builderColourTitle = $(this).attr('data-builder-colour-title');
			
			// Amend img src of result graphic to contain the new colour
			var builderGraphic = $('.js-result-graphic').find('img');
			var graphicSplit0 = builderGraphic.attr('src').split('__')[0];
			var graphicSplit2 = builderGraphic.attr('src').split('__')[2];
			builderGraphic.attr('src', graphicSplit0 + '__' + builderColour + '__' + graphicSplit2 )

			// Amend img src of corners to contain the new colour
			var builderCorner = $('.js-result-corner').find('img');
			var builderCornerPathWithoutColour = builderCorner.attr('src').split('__')[0];
			builderCorner.attr('src', builderCornerPathWithoutColour + '__' + builderColour + '.png' )
			
			// Amend img src of corner buttons to contain the new colour
			$('.js-builder-corner-button').each(function() {
				var builderCornerButton = $(this).find('img');
				var builderCornerButtonPathWithoutColour = builderCornerButton.attr('src').split('__')[0];
				builderCornerButton.attr('src', builderCornerButtonPathWithoutColour + '__' + builderColour + '.png' )
			});

			// Update the colour line item option & selection text
			$('.js-builder-line-item-colour').attr('value', builderColourTitle)
			$('.js-builder-selection-colour').text(builderColourTitle)

			$("[data-slider='pdp-slider']").slick("slickGoTo", 0);
		});

		// ********************
		// corner option button click
		// ********************
		$(".js-builder-corner-button").on("click", function () {
			var baseTileImage = $(this).find('.pdp-builder__item-image').attr('src');
			$('.js-result-corner').find('img').attr('src', baseTileImage);
			$('.js-result-corner').removeClass("hidden");

			// Add 'selected' style to active choice
			$(this).closest('ul').children('li').removeClass('pdp-builder__item--selected');
			$(this).closest('li').addClass('pdp-builder__item--selected');

			// Update the corner line item option & selection text
			var cornerTitle = $(this).find('.pdp-builder__item-title').text();
			$('.js-builder-line-item-corner').attr('value', cornerTitle)
			$('.js-builder-selection-corner').text(cornerTitle)

			$("[data-slider='pdp-slider']").slick("slickGoTo", 0);
		});

		// ********************
		// colour option remove button click
		// ********************
		$(".js-builder-corner-remove-button").on("click", function () {
			$('.js-result-corner').find('img').attr('src', '');
			$('.js-result-corner').addClass("hidden");
			$('.js-builder-line-item-corner').attr('value', 'No corner')
			$('.js-builder-selection-corner').text("No corner")

			// Remove 'selected' style from corner options
			$(this).closest('ul').children('li').removeClass('pdp-builder__item--selected');

			$("[data-slider='pdp-slider']").slick("slickGoTo", 0);
		});

		
	}

	
}
pdpBuilder();

// **************************************************************
// **************************************************************
// COL SORTER (JOURNAL)

function cols() {

  var dataCols = $(".cols").attr("data-cols");
	var columns = parseInt(dataCols);
  
	if ($(window).width() <= 1000) {
		var columns = 3
	}
  
	if ($(window).width() <= 900) {
		var columns = 2
	}

	if ($(window).width() <= 550) {
		var columns = 1
	}
  
	var count = 0
	var content = $(".cols > *");
  
  $(".cols").before("<div class='cols-columns'></div>");

	content.each(function(index) {
		count = count + 1
		$(this).addClass("cols-sort-" + count + "")

		if (count == columns) {
			count = 0
		}
	});
  
  for(var i = 0 + 1; i < columns + 1 ; i++) {
    $(".cols-columns").append("<div class='cols-"+ i +"'></div>")
    $(".cols-sort-" + i).appendTo(".cols-" + i);
  }
}
cols();

function inViewport(targetClass){
	$(targetClass).each(function(){
		var triggerHeight = $(window).innerHeight() / 1.3;
		var divPos = $(this).offset().top;
		var topOfWindow = $(window).scrollTop();
		var activeClass = targetClass.replace('.','') + "--in-viewport";
		var inactiveClass = targetClass.replace('.','') + "--not-in-viewport";

		if (divPos <= topOfWindow + triggerHeight ) {
			$(this).addClass(activeClass);
			$(this).removeClass(inactiveClass)
		} else {
			$(this).removeClass(activeClass)
			$(this).addClass(inactiveClass)

			// used on the gallery page - this will remove the active class on the gallery modal
			var activeAdviceModal = $("[data-js-advice-modal].active");
			if ($(activeAdviceModal)[0]) {
				activeAdviceModal.removeClass("active")
			}
		}
	});
}
function inViewportTargets(){
	inViewport(".advice-listing__item");
	inViewport(".gallery-item");
}


// **************************************************************
// **************************************************************
// SIMPLE ACCORDION

$(document).ready(function(){
	if ($(".form__row--file")[0]) {
		var fileInput = $(".form__row--file").find("input")
		$(fileInput).on('change',function(){
			var fileName = "File Selected: " + $(this).val().replace(/C:\\fakepath\\/i, '');
			var fileMessage = $(this).closest(".form__row--file").find(".form__row--file-message");
			$(fileMessage).text(fileName);
			console.log(fileName)
		});
	}
});



function simpleAccordion() {
    $('.js-simple-accordion').each(function() {
		$(".simple-accordion__content").slideUp();
		$(this).closest('.row').addClass('simple-accordion-wrapper');

		$(".simple-accordion__heading").unbind().click(function (event) {
			if ($(this).hasClass("simple-accordion__heading--open")) {
				$(this).removeClass("simple-accordion__heading--open");
				$(this).siblings(".simple-accordion__content").slideUp();
			} else {
				$(this).addClass("simple-accordion__heading--open");
				$(this).siblings(".simple-accordion__content").slideDown();
			}
		});
	});
}
simpleAccordion();


// Temporary - adding this for a quick fix as there isn't a single specific class on this site
if ($(".list-item__slider")[0]) {
	$(".list-item__slider").closest('.gl.gl--gutter').addClass('flex-cols');
};


// Adding a conditional style via JS because the strange templating makes the parent container inaccessible from the contents
if ($(".js-square-slider")[0]) {
	$(".js-square-slider").closest('.row').css('overflow','hidden');
};



// **************************************************************
// **************************************************************
// EQUAL HEIGHTS

function heights() {
    $('.js-heights').each(function() {
		var $tallest = 0;
		var $heightItem = $(this).find('.js-heights__item');
		
		$heightItem.each(function() {
            if ($(this).height() > $tallest) {
                $tallest = $(this).height();
            }
        })
       $heightItem.height($tallest);
	});
}

heights();


// **************************************************************
// **************************************************************
// PDP STICKY COL MARGIN

function pdpIntroHeight() {
    if ($(".product-details__intro")[0]) {
        if ($(window).width() > $pdpBreakOne) {
            var introHeight = $('.product-details__intro').outerHeight();
            var introHeight = '-' + introHeight + 'px';
            $('.product-details__images').css('margin-top', introHeight);
        }
    }
}
pdpIntroHeight();

// **************************************************************
// **************************************************************
// PDP IMAGE ZOOMING

function zoomImageContainer() {
	if ($(window).width() > $pdpBreakOne) {
		if ($(".zoom").length) {
			$(".zoom").each(function () {
				var $src = $(".zoom").attr("src");
				var $originalDimensions = $(".zoom").outerHeight();

				var $newEl =
					'<div style="height: ' +
					$originalDimensions +
					'px;" class="product-images__zoom-container"><div class="product-images__zoom-image" style="background-image:url(' +
					$src +
					');"></div></div>';
				$(this).replaceWith($newEl);
			});
		}
	}
}

function zoomImage() {
	if ($(window).width() > $pdpBreakOne) {
		if ($(".product-images__zoom-container").length) {
			$(".product-images__zoom-container").each(function () {
				var $zoomed = false;

				$(".product-images__zoom-container").on("click", function () {
					if ($zoomed) {
						$(this).removeClass("product-images__zoom-container--zoomed");
						$zoomed = false;
					} else {
						$zoomed = true;
						$(this).addClass("product-images__zoom-container--zoomed");
					}
				});

				$(".product-images__zoom-container").on("mousemove", function (e) {
					$(this)
						.children(".product-images__zoom-image")
						.css({
							"transform-origin":
								((e.pageX - $(this).offset().left) / $(this).width()) * 100 +
								"% " +
								((e.pageY - $(this).offset().top) / $(this).height()) * 100 +
								"%",
						});
				});
				$(".product-images__zoom-container").on("mouseleave", function () {
					$(this).removeClass("product-images__zoom-container--zoomed");
					$zoomed = false;
				});
			});
		}
	}
}


// **************************************************************
// **************************************************************
// NAV POSITIONING & STICKY HEADER

// The promo banner was overlapping the nav & making it impossible to close.
// This gets the banner height & adds it to some of the mobile nav elements.

function stickyHeader() {
	if ($(document).scrollTop() >= 100) {
		$('.header').addClass('header--stuck');
	}
	else {
		$('.header').removeClass('header--stuck');
	}
}

if ($(".promo-banner")[0]) {
	const bannerHeight = $('.promo-banner').outerHeight();

	if ($(window).width() < 992) {
		$(".header .menu").css('padding-top', bannerHeight + 100 + 'px');
		$(".header .submenu").css('padding-top', bannerHeight + 100 + 'px');
		$(".header .menu__link--back").css('top', bannerHeight + 15 + 'px');
	}

	// Adds some extra 'top' space to sticky header if the banner is present
	$('.header').css('top', bannerHeight + 'px');

	$(".promo-banner__close").on("click", function () {
		$('.header').css('top', '0');
	});
}


$(window).on("load", function () {
	zoomImageContainer();
	zoomImage();
    pdpIntroHeight();
    heights();
});

// ******************************
// ******************************

$(".inlinesvg").inlinesvg();

function addToCartGAEvent($form) {
	if($form[0].dataset.hasOwnProperty('datalayerItem')) {
		let item = JSON.parse($form[0].dataset.datalayerItem);
		Object.assign(item, { quantity: +$form.find('[name="qty"]').val() });

		dataLayer = window.dataLayer || [];
		dataLayer.push({ 'ecommerce': null });
		dataLayer.push({
		  'event': 'add_to_cart',
		  'ecommerce': {
			'items': [item]
		  }
		});
	}
};

// Utilities and behaviours namespaced to $moreJs
// use these functions by calling $moreJs.method();
window.$moreJs = {
	// function for setting cookies
	setCookie: function (name, value, days) {
		var expires = "";
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "") + expires + "; path=/";
	},

	// function for getting cookies
	getCookie: function (name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(";");
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == " ") c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	},

	// function to erase a cookie
	eraseCookie: function (name) {
		document.cookie = name + "=; Max-Age=-99999999;";
	},

	calculator: function () {
		const $newMeasurementBtn = $("[data-add-measurement]");
		const $measurements = $("[data-measurements]");
		const $calculateBtn = $("[data-calculate-qty]");
		const $removeMeasurement = $("[data-remove-measurement]");
		const options = (window.paymentCurrency === 'USD') ? `<option value="ft">Feet</option>` : `<option value="m">Metres</option>
                          <option value="cm">Centimetres</option>`;
		const measurementMarkup = `
            <div class="calculator__row calculator__row--measurement" data-measurement="value" data-calc-row>
                <div class="calculator__col">
                    <label class="form__label form__label--hidden" for="width">Width</label>
                    <div class="form__input-wrap">
                        <input type="number" class="form__input" data-calc-row-width>
                    </div>
                </div>
                <div class="calculator__col">
                    <label class="form__label form__label--hidden" for="height">Height</label>
                    <div class="form__input-wrap">
                        <input type="number" class="form__input" data-calc-row-height>
                    </div>
                </div>
                <div class="calculator__col calculator__col--unit">
                    <label class="form__label form__label--hidden" for="unit">Unit</label>
                    <div class="form__input-wrap form__input-wrap--select">
                        <select class="form__input form__input--select" data-calc-row-unit>
                            ${options}
                        </select>
                    </div>
                </div>
                <div class="calculator__col calculator__col--rowtotal">
                    <span data-calc-row-total="0"></span>
                </div>
                <div class="calculator__col calculator__col--remove">
                    <button class="button btn btn--plain btn--tertiary" data-remove-measurement>Remove</button>
                </div>
            </div>
        </div>
        `;

		$newMeasurementBtn.on("click", function (e) {
			e.preventDefault();
			$measurements.append(measurementMarkup);
		});

		$(document).on("click", "[data-remove-measurement]", function (e) {
			e.preventDefault();
			$(this).parent().parent().remove();
			updateCalculatorTotal();
		});

		$(document).on(
			"click",
			".js-add-to-basket, [data-add-to-basket]",
			function (e) {
				e.preventDefault();

				var $form = $(this).parents("form:first");

				// prep the form data
				var $formdata = $form.serializeArray();

				$formdata.push({
					name: window.csrfTokenName,
					value: window.csrfTokenValue,
				});

				var $url = $form.find('[name="action"]').attr("value");

				// update button text
				var $button = $form.find('[type="submit"]');
				var $buttonText = $button.html();

				$.ajax({
					type: "POST",
					url: $url,
					data: $formdata,
					dataType: "json",
					beforeSend: function ($data) {
						$button.attr("disabled", "disabled");
						$button.html("Please wait…");
					},
					success: function ($data) {
						// show feedback
						if ($data.message === "Cart updated.") {
							// update header basket total
							const $headerBasket = $("#js-header-basket-container");
							$headerBasket.load(window.siteBaseUrl + "layout/header #header-basket>a");
							let $purchasableIdSelect = null;
							let $popupVariantTitle = null;
							let lineItem = null;

							// show confirmation overlay
							openOverlay("basketPopUp");

							$purchasableIdSelect = $form.find(
								'select[name="purchasableId"]:first'
							);
							$popupVariantTitle = $(
								'[data-overlay="basketPopUp"] [data-title]'
							);

							if ($data.cart && $purchasableIdSelect.length) {
								lineItem = $data.cart.lineItems.find(
									(li) => li.purchasableId == $purchasableIdSelect.val()
								);

								if (lineItem && $popupVariantTitle.length) {
									$popupVariantTitle.text(lineItem.description);
								}
							}

							// show lead time message if necessary
							// if (checkStock($form) == false) {
							// 	$('[data-overlay="basketPopUp"]')
							// 		.find("[data-leadTimeNote]")
							// 		.html(
							// 			"<br><p><b>Please note</b> Delivery time will be approximately 2-3 weeks</p>"
							// 		);
							// }

							if (typeof pintrk === "function") {
								var purchaseValue = $form
                                .find("[data-purchase-total]")[0]
                                .innerText.replace(/^£/g, "");
								var qty = $form.find('[name="qty"]').val();

								pintrk("track", "addtocart", {
									value: purchaseValue,
									order_quantity: qty,
									currency: "GBP",
								});
							}

							addToCartGAEvent($form);
						} else {
							if ($data.errors.length < 1) {
								return;
							}

							var firstErrorKey = Object.keys($data.errors)[0];

							if(firstErrorKey.endsWith('.qty')) {
								$('#main').find('[data-flash]').remove();
								$('#main').prepend(`<div data-flash class="flash flash--error">Product not added to basket. ${$data.errors[firstErrorKey][0]}</div>`);

								setTimeout(function () {
									$("[data-flash]").addClass("is-active");
								}, 50);

								setTimeout(function () {
									$("[data-flash]").removeClass("is-active");
								}, 3000);
							}
						}
					},
					error: function ($data) {
						// show an error
						// console.log("error", $data);
					},
					complete: function ($data) {
						$button.html($buttonText);
						$button.removeAttr("disabled");
					},
				});

				/*
            var $isInStock = checkStock($form)

            if($isInStock == false){
                e.preventDefault();
                $('[data-overlay="stockNotice"]').addClass(activeClass).addClass(visibleClass);
            }
            */
			}
		);

		$calculateBtn.on("click", function (e) {
			e.preventDefault();
			const target = $(this).closest(".overlay").attr("data-overlay");

			// Above closes the calculator overlay, below will deal with populating the appropriate fields in the front end.
			var $total = $("[data-calc-total]").attr("data-calc-total");

			// add 10% if required
			if ($("[data-calc-wastage]").is(":checked") && $total > 0) {
				$total = $total * 1.1;
			}

			$("[data-calcarea]").val($total).trigger("keyup").trigger("change");

			closeOverlay(target);
			hideMask(target);

			// Also, potentially consider clearing the rows of measurements, but saving them could be more beneficial to the user.
		});

		// variant selection behaviour to update prices and totals
		$("[data-select-variant]").on("change", function (e) {
			var $form = $(this).parents("form");
			var $selection = $(this).find(":selected").data("variant-price");
			var $selectionNoVat = $(this).find(":selected").data("variant-price-without-vat");
			var $priceElement = $form.find("[data-price-each]");
			var unit = (window.paymentCurrency == 'USD') ? '$':'£';
			$priceElement
				.attr("data-price-each", $selectionNoVat)
				.html(unit + $selection);
			updatePurchaseTotal($form);
		});

		$("[data-calcqty]").on("keyup change", function (e) {
			var $form = $(this).parents("form");
			var $qty = $form.find("[data-calcqty]").val();
			var $area = $form.find("[data-calcarea]").val();

			$qty = Math.ceil($qty);

			if ($form.find("[data-calcarea]").length >= 1) {
				// get the number of tiles per sqm/sqft
				var $numTiles = $form.find("[data-calcarea]").attr("data-perm");
				$area = $moreJs.round($qty / $numTiles, 2);
				updateFields($form, $qty, $area);
			}

			updatePurchaseTotal($form);
		});

		$("[data-calcarea]").on("keyup change", function (e) {
			if (e.keyCode == 190 || e.keyCode == 110) return false;
			var $form = $(this).parents("form");
			var $qty = $form.find("[data-calcqty]").val();
			var $area = $form.find("[data-calcarea]").val();
			// get the number of tiles per sqm/sqft
			var $numTiles = $form.find("[data-calcarea]").attr("data-perm");

			$qty = $area * $numTiles;

			$area = $moreJs.round($qty / $numTiles, 2);

			updateFields($form, $qty, $area);
			updatePurchaseTotal($form);
		});

		// area calculations
		$("[data-measurements]").on(
			"change",
			"[data-calc-row-width], [data-calc-row-height], [data-calc-row-unit]",
			function () {
				var $result = 0;
				var $row = $(this).parents("[data-calc-row]");
				var $w = $row.find("[data-calc-row-width]").val();
				var $h = $row.find("[data-calc-row-height]").val();

				// get unit and set conversion factor to m2
				var $unit = $row.find("[data-calc-row-unit]").val();
				var $conversionFactor = 1; // base unit is meters
				/*
            if($unit == 'cm'){
                $conversionFactor = 100;
            } else if($unit == 'ft') {
                $conversionFactor = 3.28084;
            } else if($unit == 'in') {
                $conversionFactor = 39.3701;
            }

            var $total = ($w / $conversionFactor) * ($h / $conversionFactor);
            */
				let unit = 'm';
				let $total = 0;

				if(window.paymentCurrency == 'USD') {
					$total = ($w * $h);
					unit = 'ft';
				} else {
					if ($unit == "cm") {
						$conversionFactor = 10000;
					} else if ($unit == "ft") {
						$conversionFactor = 10.7639;
					} else if ($unit == "in") {
						$conversionFactor = 1550.003;
					}
					
					$total = ($w * $h) / $conversionFactor;
				}
				

				var $result = $moreJs.round($total, 2);
				if ($result != 0) {
					// update row total
					$row
						.find("[data-calc-row-total]")
						.attr("data-calc-row-total", $result)
						.html($result + unit + "<sup>2</sup>");
				}

				updateCalculatorTotal();
			}
		);

		function updateCalculatorTotal() {
			// update grand total
			var $grandTotal = 0;
			var $rowTotal;
			$("[data-calc-row]").each(function () {
				$rowTotal = Number(
					$(this).find("[data-calc-row-total]").attr("data-calc-row-total")
				);
				$grandTotal += $rowTotal;
			});
			$("[data-calc-total]")
				.attr("data-calc-total", $moreJs.round($grandTotal, 2))
				.text($moreJs.round($grandTotal, 2));
		}

		function updateFields($form, $qty, $area) {
			$form.find("[data-calcarea]").val($area);
			$form.find("[data-calcqty]").val(Math.ceil($qty)); // use Math.ceil to round UP to next whole tile
		}

		function updatePurchaseTotal($form) {
			var $isInStock = checkStock($form);
			if ($isInStock) {
				$("[data-leadtime]").html("3-4 days");
			} else {
				$("[data-leadtime]").html("2-3 weeks");
			}
			var $qty = $form.find("[data-calcqty]").val();
			var $pricePerTile = $form
				.find("[data-price-each]")
				.attr("data-price-each");
			//console.log("per tile " + $pricePerTile);
			var $purchaseTotal = $pricePerTile * $qty;

			$form
				.find("[data-purchase-total]")
				.html($moreJs.round($purchaseTotal, 2).toFixed(2));
		}

		function checkStock($form) {
			var $qty = $form.find("[data-calcqty]").val();
			var $stock = $form.find("[data-calcqty]").data("stock");
			if ($qty > $stock) {
				return false;
			} else {
				return true;
			}
		}
	},

	// better rounding function
	round: function (value, decimals) {
		//return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
		//return Number(Math.ceil(value+'e'+decimals)+'e-'+decimals);
		return Number(
			Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals)
		);
	},

	roundArea: function (value) {
		return Math.round(value * 2) / 2;
	},

	// zoomImage: function() {
	//     if ($('.zoom').length) {
	//         var $src = $('.zoom').attr('src');
	//         var $el = '<div class="tile" data-scale="1.7" data-image="' + $src + '"></div>';
	//         var $zoomed = false;
	//         $('.zoom').replaceWith($el)
	//         $('.tile')
	//             // tile mouse actions
	//             .on('click', function() {
	//                 if ($zoomed) {
	//                     $(this).removeClass('zoomed').children('.photo').css({ 'transform': 'scale(1)' });
	//                     $zoomed = false;
	//                 } else {
	//                     $zoomed = true;
	//                     $(this).addClass('zoomed').children('.photo').css({ 'transform': 'scale(' + $(this).attr('data-scale') + ')' });
	//                 }
	//             })
	//             /*.on('click', function(){
	//             	$(this).children('.photo').css({'transform': 'scale(1)'});
	//             })*/
	//             .on('mousemove', function(e) {
	//                 $(this).children('.photo').css({ 'transform-origin': ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '% ' + ((e.pageY - $(this).offset().top) / $(this).height()) * 100 + '%' });
	//             })
	//             .on('mouseleave', function() {
	//                 $(this).removeClass('zoomed').children('.photo').css({ 'transform': 'scale(1)' });
	//                 $zoomed = false;
	//             })
	//             // tiles set up
	//             .each(function() {
	//                 $(this)
	//                     // add a photo container
	//                     .append('<div class="photo"></div>')
	//                     // set up a background image for each tile based on data-image attribute
	//                     .children('.photo').css({ 'background-image': 'url(' + $(this).attr('data-image') + ')' });
	//             })
	//     }
	// }
};

// MENU
//const find = require("jspolyfill-array.prototype.find")

// Misc elements
const $body = $("html");

// Mobile menu elements
const $hamburger = $(".hamburger");

// Menu elements
const $menu = $(".menu");
const $submenu = $(".submenu");
const $menuLink = $(".js-menu-link");

// Classes
const bodyMenuClass = "is-hidden";
const activeClass = "is-active";
const visibleClass = "is-visible";

/*
    Menu hiding & showing using display block & none for accessibility purposes.
*/

function closeMenu() {
	$body.removeClass(bodyMenuClass);

	// Update button attributes
	$hamburger.attr("aria-expanded", "false");

	// Hide the menu drawer
	$menu.removeClass(visibleClass);
	$menu.attr("aria-hidden", "true");
	setTimeout(function () {
		$menu.removeClass(activeClass);

		// Hide submenu
		$submenu.removeClass(activeClass);
		$submenu.removeClass(visibleClass);
	}, 200);

	// Revert the hamburger to normal
	$hamburger.removeClass(activeClass);
}

function openMenu() {
	$body.addClass(bodyMenuClass);
	$hamburger.attr("aria-expanded", "true");
	$menu.addClass(activeClass);
	$menu.attr("aria-hidden", "false");
	setTimeout(function () {
		$menu.addClass(visibleClass);
	}, 200);
	$hamburger.addClass(activeClass);
}

// Hamburger click event
$hamburger.click(function () {
	if ($body.hasClass(bodyMenuClass)) {
		closeMenu();
	} else {
		openMenu();
	}
});

// Menu link click event
$menuLink.on("click", function (e) {
	if ($(window).width() < 1100) {
		closeMenu();
	}
});

// Open child menu
$("[data-more]").on("click", function (e) {
	e.preventDefault();

	// Get the target menu
	const target = $(this).parent().attr("data-parent");

	// Show the target item
	$(`[data-submenu='${target}']`).addClass(activeClass);

	setTimeout(function () {
		$(`[data-submenu='${target}']`).addClass(visibleClass);
	}, 20);
});

// Submenu back button
$("[data-back]").on("click", function () {
	$(this).closest(".submenu").removeClass(visibleClass);

	$(this)
		.closest(".submenu")
		.one("transitionend", function (e) {
			$(this).closest(".submenu").removeClass(activeClass);
		});
});

// // Making the submenus inactive when another top item is focussed
$(".menu__link--top").focus(function () {
	if ($(window).width() > 767) {
		$('.submenu[data-level="2"]').removeClass(activeClass);
		$('.submenu[data-level="2"]').removeClass(visibleClass);
	}
});

// On hover remove any 'is-active' classes added by JS when user is tabbing.

$(".menu__item--top").mouseover(function () {
	if ($(window).width() > 991) {
		$('.submenu[data-level="2"]').removeClass(activeClass);
		$('.submenu[data-level="2"]').removeClass(visibleClass);
	}
});

// Accordions

if ($(".js-accordion").length > 0) {
	$(".js-accordion").each(function (i, el) {
		new Accordion(el, {
			heightOffset: 1,
		});
	});
}

// Slick slider

$("[data-slider='pdp-slider']").slick({
	arrows: true,
	slidesToShow: 1,
	asNavFor: "[data-slider='pdp-slider-nav']",
	dots: false,
});

$("[data-slider='pdp-slider-nav']").slick({
	arrows: true,
	slidesToShow: 4,
	slidesToScroll: 1,
	asNavFor: "[data-slider='pdp-slider']",
	dots: false,
	focusOnSelect: true,
});


$("[data-slider='base']").slick({
    arrows: false,
    slidesToShow: 1,
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000,
    lazyLoad: 'ondemand'
})

$("[data-slider='testimonial']").slick({
	arrows: false,
	slidesToShow: 2,
	dots: true,
	autoplay: true,

	responsive: [
		{
			breakpoint: 768, // 1280
			settings: {
				slidesToShow: 1,
			},
		},
	],
});

$("[data-slider='logos']").slick({
	arrows: false,
	slidesToShow: 4,
	dots: true,
	autoplay: true,
	lazyLoad: 'ondemand',

	responsive: [
		{
			breakpoint: 768, // 1280
			settings: {
				slidesToShow: 2,
			},
		},
	],
});


if ($('.js-list-item-slider')[0]) {
    $(".js-list-item-slider").slick({
        lazyLoad: 'ondemand',
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false
    })
}

if ($('.js-text-media-slider')[0]) {
    $(".js-text-media-slider").slick({
        arrows: true,
        slidesToShow: 1,
        dots: true
    })
}

if ($('.js-categorySlider')[0]) {
    $(".js-categorySlider").slick({
        slidesToShow: 1,
        dots: false
    })
}


if ($('.js-square-slider')[0]) {

	// Have to handle the responsive slider this way due to a bug in slick where the responsive property breaks any buttons inside the slider. some detail here https://github.com/kenwheeler/slick/issues/1015
	if ($(window).width() > 580) {
		$(".js-square-slider").slick({
			slidesToShow: 4,
			dots: true,
			infinite: true,
		});
	}
	
	if ($(window).width() <= 580) {
		$(".js-square-slider").slick({
			slidesToShow: 3,
			dots: true,
			infinite: true,
		});
	}
}

if ($('.js-square-slider-contained')[0]) {
	if ($(window).width() > 580) {
		$(".js-square-slider-contained").slick({
			slidesToShow: 4,
			dots: true,
			infinite: false,
		});
	}

	if ($(window).width() <= 580) {
		$(".js-square-slider-contained").slick({
			slidesToShow: 1,
			dots: true,
			infinite: false,
		});
	}
}

if ($('.js-pdp-listing-slider-wrapper')[0]) {
	if ($(window).width() > 580) {
		$(".js-pdp-listing-slider-wrapper").slick({
			lazyLoad: 'ondemand',
			slidesToShow: 4,
			dots: false,
			infinite: true,
		});
	}
	
	if ($(window).width() <= 580) {
		$(".js-pdp-listing-slider-wrapper").slick({
			lazyLoad: 'ondemand',
			slidesToShow: 2,
			dots: false,
			infinite: true,
		});
	}
}

function relatedSlider(slider) {
	slider.slick({
		arrows: false,
		slidesToShow: 3,
		dots: true,
		infinite: false,

		responsive: [
			{
				breakpoint: 720,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 500,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	});
}

$(window).on("load resize orientationchange", function (e) {
	const $relatedSlider = $('[data-slider="related"]');

	if ($(window).width() > 768) {
		if ($relatedSlider.hasClass("slick-initialized")) {
			$relatedSlider.slick("unslick");
		}
	} else {
		if (!$relatedSlider.hasClass("slick-initialized")) {
			relatedSlider($relatedSlider);
		}
	}
});

// $("[data-slider='thumbnail']").slick({
//     arrows: false,
//     slidesToShow: 3,
//     dots: false,
//     vertical: true,
//     verticalSwiping: true,

//     responsive: [
//         {
//             breakpoint: 992, // 'xl' CSS breakpoint
//             settings: {
//                 vertical: false,
//                 verticalSwiping: false,
//                 slidesToShow: 3,
//                 dots: true,
//             }
//         },
//         {
//             breakpoint: 768, // 'md' CSS breakpoint
//             settings: {
//                 slidesToShow: 4,
//                 dots: false,
//                 vertical: true,
//                 verticalSwiping: true,
//             }
//         },
//         {
//             breakpoint: 568, // 'sm' CSS breakpoint
//             settings: {
//                 vertical: false,
//                 verticalSwiping: false,
//                 slidesToShow: 4,
//                 dots: true,
//             }
//         }
//     ]
// })

// Triggered on resize, or when switching from landscape to portrait on mobile
// $(window).on('resize orientationchange', function(){
//     var wW = $(window).width();

//     $('[]').slick('resize');

// }); // winResize

$("[data-slider='product-card-slider']").each(function () {
	const slides = $(this).children('img');

	$(this).slick({
		infinite: true,
		fade: true,
		arrows: false,
		dots: true,
		draggable: true,
		swipe: true,
		mobileFirst: true,
		lazyLoad: 'ondemand',
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					arrows: true,
					dots: false,
					draggable: false,
					swipe: false,
					initialSlide: 1,
					prevArrow: $(this).parents('.product-card__gallery').find('.product-card__gallery-arrow--prev'),
					nextArrow: $(this).parents('.product-card__gallery').find('.product-card__gallery-arrow--next')
				}
			}
		]
	})
})

// Details Summary/Accordions
const detailSummary = $('.introduction__collapse-text');
const control = $('.introduction__collapse-expander');
let viewportWidth = $(window).width();

detailSummaryControl(viewportWidth, detailSummary, control);

$(window).resize(() => {
	viewportWidth = $(window).width();

	detailSummaryControl(viewportWidth, detailSummary, control);
})

function detailSummaryControl(viewportWidth, detailSummary, control) {
	if (detailSummary.hasClass('disabled')) {
		e.preventDefault();
	} else {
		detailSummary.removeClass('open');

		control.on('click', (e) => {
			e.preventDefault();
			detailSummary.addClass('open');
			detailSummary.addClass('disabled')
		});
	}
}

// Overlay

let focusedElementBeforeModal;
var focusableElementsString =
	"a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";

const $overlay = $("[data-overlay]");
const $overlayBtn = $("[data-overlay-target]");
const $header = $(".header");

// On click of button with overlay data attrs
$overlayBtn.on("click", function (e) {
	e.preventDefault();
	// Get the target overlay
	const target = $(this).attr("data-overlay-target");

	// If it's open, close it else open it.
	if ($(`[data-overlay='${target}']`).hasClass(activeClass)) {
		closeOverlay(target);
	} else {
		openOverlay(target);
		$header.addClass("header--hidden");


		// if (target == "search") {
		//     console.log("hello")
		//     $('.search-form__input').focus();
		//     $('.search-form__input').addClass("hello");
		// }
	}
});

// Close overlay function
function closeOverlay(target) {
	// Get the targeted overlay
	const $currOverlay = $(`[data-overlay='${target}']`);

	// Make the site scrollable again
	$body.removeClass(bodyMenuClass);
	$header.removeClass("header--hidden");

	// Hide the targeted overlay
	$currOverlay.removeClass(visibleClass);
	hideMask(target);
	$currOverlay.removeAttr("open");

	$(`[data-overlay-target='${target}']`).prop("disabled", false);

	setTimeout(function () {
		$currOverlay.removeClass(activeClass);
	}, 200);
}

// Open overlay function
window.openOverlay = function(target) {
	if (DEBUG) console.log(target, "is opened");

	const $currOverlay = $(`[data-overlay='${target}']`);

	$currOverlay.attr("open", "");

	// Stop the page scrolling
	$body.addClass(bodyMenuClass);

	// Disable the open button until it's closed
	$(`[data-overlay-target='${target}']`).prop("disabled", true);

	$currOverlay.addClass(activeClass);
	setTimeout(function () {
		var overlayType = $currOverlay.attr("data-overlay");
		if (overlayType == "search") {
			$currOverlay.find("#search").focus();
		} else {
			$currOverlay.find("*").filter("input:visible:first").focus();
		}

		$currOverlay.addClass(visibleClass);

		// Trapping tabbing
		let focusedElementBeforeModal;

		$currOverlay.keydown(function (event) {
			trapTabKey($(this), event);
		});
	}, 200);

	showMask(target);
}

// Close the menu or search pop on esc key
$(document).on("keydown", function (e) {
	if (e.keyCode === 27) {
		// ESC
		if ($(window).width() > 979) {
			if ($(".submenu").hasClass(activeClass)) {
				$(".submenu").removeClass(activeClass);
			}
		} else {
			$(".submenu").removeClass(activeClass);
			$(".submenu").removeClass(visibleClass);
			closeMenu();
		}

		if ($(".mask").hasClass(activeClass)) {
			const target = $(".mask").attr("data-use");

			closeOverlay(target);
			hideMask(target);
		}
	}
});

function trapTabKey(obj, evt) {
	// if tab or shift-tab pressed
	if (evt.which == 9) {
		// get list of all children elements in given object
		var o = obj.find("*");

		// get list of focusable items
		var focusableItems;
		focusableItems = o.filter(focusableElementsString).filter(":visible");

		// get currently focused item
		var focusedItem;
		focusedItem = jQuery(":focus");

		// get the number of focusable items
		var numberOfFocusableItems;
		numberOfFocusableItems = focusableItems.length;

		// get the index of the currently focused item
		var focusedItemIndex;
		focusedItemIndex = focusableItems.index(focusedItem);

		if (evt.shiftKey) {
			//back tab
			// if focused on first item and user preses back-tab, go to the last focusable item
			if (focusedItemIndex == 0) {
				focusableItems.get(numberOfFocusableItems - 1).focus();
				evt.preventDefault();
			}
		} else {
			//forward tab
			// if focused on the last item and user preses tab, go to the first focusable item
			if (focusedItemIndex == numberOfFocusableItems - 1) {
				focusableItems.get(0).focus();
				evt.preventDefault();
			}
		}
	}
}

// Close search if anything but search is clicked

// $(document).on('click', function(e) {
//     setTimeout(function () {
//         if ($searchPop.hasClass(activeClass)) {
//             closeSearch()
//         }
//     }, 200);
// });

// $searchPop.on('click', function(e) {
//     e.stopPropagation()
// });

// Show mask

function showMask(target) {
	$(".mask").addClass(activeClass);
	$(".mask").attr("data-use", target);
}

function hideMask(target) {
	$(`.mask`).removeClass(activeClass);
	// const closeTarget = $('.mask').attr('data-use')

	$(".mask").attr("data-use", "");
}

$(".mask").on("click", function () {
	const target = $(this).attr("data-use");
	closeOverlay(target);
});

$(document).on("click", "[data-close-overlay]", function (e) {
	e.preventDefault();

	var target = $(this).parents().attr("data-overlay");

	// weirdly the above doesn't seem to traverse more than 1 level up the DOM to find the parent
	if (typeof target == "undefined") {
		var target = $(this)
			.parent()
			.parent()
			.parent()
			.parent()
			.attr("data-overlay");
	}

	closeOverlay(target);
});

$("[data-filter]").on("click", function (e) {
	$(this).parents("label").toggleClass("is-active");
});

// Show password

$("[data-show-pass]").on("click", function (e) {
	e.preventDefault();

	const value = $(this).attr("data-show-pass");
	const field = $(this).parent().find("input[name='password']");

	if (value == "false") {
		$("[data-show-pass]").attr("data-show-pass", "true");
		field.prop("type", "text");
		$(this).html("Hide");
	} else {
		$("[data-show-pass]").attr("data-show-pass", "false");
		field.prop("type", "password");
		$(this).html("Show");
	}
});

// Product thumbnails
// if ($('[data-main-img]').length > 0) {
//     $('[data-thumb]').on('click', function() {
//         const src = $(this).attr('data-thumb')

//         //$('[data-main-img] img').attr('src', src)
//         $('[data-main-img] .tile').attr('data-image', src).find('.photo').css({ 'background-image': 'url(' + src + ')' });
//         $('[data-main-img] figcaption').text($(this).data('caption'))
//         $('.thumbs__btn').removeClass('is-active')
//         $(this).addClass('is-active')
//         // $moreJs.zoomImage();
//     })
// }

if ($("#colourCombo").length > 0) {
	$("#colourCombo").on("change", function (e) {
		var $img = $("option:selected", this).attr("data-img");
		var $el = $("[data-main-img]").find(".photo");
		var $baseTile = $(".js-base-tile");

		$el.animate(
			{
				opacity: 0,
			},
			300,
			function () {
				$el
					.css("background-image", "url(" + $img + ")")
					.animate({ opacity: 1 }, 300);
			}
		);

		$baseTile
			.find("img")
			.attr("src", $("option:selected", this).attr("data-baseimg"));
		$baseTile
			.find(".product__title")
			.html($("option:selected", this).attr("data-basetitle"));

		// set the option value on the sample add to cart form
		$(".js-sample-colour").val($("#colourCombo").val());
	});
}

if ($(".js-sample-colour").length) {
	$(".js-sample-colour").val($("#colourCombo").val());
}

// Social sharing

if ($("[data-sharing]").length > 0) {
	const $socialWindow = $("[data-share]");

	$socialWindow.on("click", function () {
		window.open(this.href, "Social", "width=800, height=600");
		return false;
	});
}

// country select
$(document).on("change", "[data-country-select]", function ($e) {
	let $value = $e.target.value;
	if (!['GB','US'].includes($value)) {
		// show modal
		openOverlay("countryPopUp");
	}
});

$(function () {
	if ($("[data-parsley]").length) {
		$("[data-parsley]").parsley({
			errorClass: "form__input--error",
			errorsWrapper: '<div class="checkout__error-container"></div>',
			errorTemplate: '<p class="checkout__error"></p>',
		});
	}
});

// Tabs
tabby.init({
	callback: function (tabs, toggle) {
		const $target = $(tabs[0]);
		// const $slider = target.children[0]

		// console.log($target)
		const $relatedSlider = $target.find('[data-slider="related"]');

		// console.log($relatedSlider)

		setTimeout(function () {
			$relatedSlider.addClass("THIS IS HERE");

			if ($(window).width() > 768) {
				if ($relatedSlider.hasClass("slick-initialized")) {
					$relatedSlider.slick("unslick");
				}
			} else {
				if (!$relatedSlider.hasClass("slick-initialized")) {
					$relatedSlider.slick("resize");
				}
			}
		}, 500);
	},
});

// Hide flash messages

if ($("[data-flash]").length > 0) {
	$("[data-flash]").addClass("is-active");

	setTimeout(function () {
		$("[data-flash]").removeClass("is-active");
	}, 3000);
}

// Scroll to JS

function scroll() {
	const $anchor = $("[data-scroll]");
	const offset = 60;
	const currUrl = window.location.pathname;

	// Animate down to section on page load if URL has it on the end
	if (window.location.hash) {
		setTimeout(function () {
			$("html, body").scrollTop(0);
			$("html, body").animate(
				{
					scrollTop: $(window.location.hash).offset().top - offset,
				},
				2000
			);
		}, 0);
	}

	// On click of anchor button
	$anchor.on("click", function (e) {
		const href = $(this).attr("href");
		const hash = this.hash;

		// If link has a hash in it
		if (hash) {
			// If there is a URL before the hash, go to this page then scroll to hash
			if (href.charAt(0) !== "#") {
				// If the URL matches the current page
				if (currUrl == href.split("#")[0]) {
					e.preventDefault();
					$("html, body").animate(
						{
							scrollTop: $(hash).offset().top - offset,
						},
						2000
					);
				} else {
					// console.log("on the page!");
				}

				// If the anchor is within the same page as the button
			} else {
				e.preventDefault();
				$("html, body").animate(
					{
						scrollTop: $(hash).offset().top - offset,
					},
					2000
				);
			}
		}
	});
}

scroll();

window.modularTiles = {
	squareFeetToMetresFactor: 10.764,

	updatePattern: function (area) {
		var tiles = $(".js-modular-tile");
		tiles.each(function () {
			var qty = modularTiles.updateTileQty($(this), area);
			modularTiles.updateTilePrice($(this), qty);
		});
		modularTiles.updateTotalPrice(modularTiles.getTotalPrice(tiles));

		return true;
	},

	updateTileQty: function (tile, area) {
		var tilePerArea = tile.data("per-area-base")
			? parseFloat(tile.data("per-area-base"))
			: 0;
		var qtyInput = tile.find(".js-tile-qty");
		var qtyText = tile.find(".js-tile-qty-text");
		var qty = Math.floor(tilePerArea * area) + 1;
		qtyText.text(isNaN(qty) ? "" : qty + " tiles");
		qtyInput.val(isNaN(qty) ? 0 : qty);

		return qty;
	},

	updateTilePrice: function (tile, qty) {
		var numberOfTiles = parseInt(qty);
		var price = parseInt(tile.data("per-tile-price") * 100);
		var total = parseFloat((numberOfTiles * price) / 100).toFixed(2);
		if (total == "NaN") {
			total = "0.00";
		}
		tile.find(".js-tile-total").text(total);
		return total;
	},

	getTilePrice(tile) {
		var numberOfTiles = parseInt(tile.find(".js-tile-qty").val());
		var price = parseInt(tile.data("per-tile-price") * 100);
		var total = parseFloat((numberOfTiles * price) / 100).toFixed(2);
		return total;
	},

	updateTotalPrice: function (amount) {
		var totalEl = $("[data-purchase-total]");
		if (!totalEl) return false;
		if (amount == "NaN") {
			$("[data-purchase-total]").text("0.00");
			return false;
		}
		$("[data-purchase-total]").text(amount);
		return true;
	},

	getTotalPrice: function (tiles) {
		var totalPrice;
		tiles.each(function () {
			totalPrice = totalPrice
				? totalPrice + parseFloat(modularTiles.getTilePrice($(this)))
				: parseFloat(modularTiles.getTilePrice($(this)));
		});
		return totalPrice.toFixed(2);
	},

	handleSubmit: function (e) {
		e.preventDefault();
		var tileForm = $(".js-add-to-cart-form");
		tileForm.submit();
		return true;
	},

	init: function (unit) {
		$("#mqty").on("keyup mouseup", function (e) {
			e.preventDefault();
			var currentValue = parseFloat($(this).val() ?? 0);

			if (currentValue.length > 7) {
				currentValue = currentValue.slice(0, 7)
				$(this).val(currentValue);
			}

			const metresSq = (unit == 'ft')? Math.floor(currentValue / modularTiles.squareFeetToMetresFactor) : currentValue;

			modularTiles.updatePattern(metresSq);
			return false;
		});
		$(".js-submit-modular-form").on("click", modularTiles.handleSubmit);
	},
};

// promobanner
$(function () {
	var banner = document.getElementById("js-promo-banner");
	var content = document.getElementById("barba-wrapper");

	if (banner) {
		var closeButton = document.getElementById("js-promo-banner-close");
		closeButton.addEventListener("click", function () {
			// remove banner
			removeFadeOut(banner, 500);
			content.style.marginTop = 0;

			// set a cookie
			$moreJs.setCookie("hidePromoBanner", "true", 0);
		});

		updateContentMargin();
		const ro = new ResizeObserver(updateContentMargin).observe(banner);
	}

	function updateContentMargin() {
		content.style.marginTop = banner.offsetHeight + "px";
	}

	function removeFadeOut(el, speed) {
		var seconds = speed / 1000;
		el.style.transition = "opacity " + seconds + "s ease";

		el.style.opacity = 0;
		setTimeout(function () {
			el.parentNode.removeChild(el);
		}, speed);
	}
});

// ****************************************
// ****************************************
// POPOVER COOKIES

// Set short duration cookie & close popover when X is clicked
$(".overlay-panel__close").click(function () {
	$moreJs.setCookie("popoverClosed", "true", 1);
	$(".overlay-panel").removeClass("overlay-panel--active");
});

// Set short duration cookie & close popover when brochure button is clicked
$(".overlay-panel__button").click(function () {
	$moreJs.setCookie("popoverClosed", "true", 1);
	$(".overlay-panel").removeClass("overlay-panel--active");
});

// Keeping the modal hidden if a user signs up to mailchimp
var modalForm = $(".overlay-panel").find("form");
var targetModal = $(".overlay-panel");

modalForm.submit(function (event) {
	event.preventDefault();

	$.ajax({
		type: modalForm.attr("method"),
		url: modalForm.attr("action"),
		data: modalForm.serialize(),
		cache: false,
		dataType: "json",
		contentType: "application/json; charset=utf-8",
		error: function (err) {
			alert(
				"Could not connect to the registration server. Please try again later."
			);
		},
		success: function (data) {
			if (data.result != "success") {
				var dataMessage = data["msg"];

				// IF USER IS ALREADY ON THE MAILCHIMP LIST, CLOSE MODAL & SET COOKIE ANYWAY
				if (dataMessage.includes("is already subscribed")) {
					targetModal.removeClass("overlay-panel--active");
					$moreJs.setCookie("popoverClosed", "true", 0);
				}
			} else {
				// SUCCESS - SUBMIT FORM, CLOSE MODAL, OPEN LINK
				targetModal.addClass("overlay-panel--success");
				$moreJs.setCookie("popoverClosed", "true", 0);
			}
		},
	});
});

// ****************************************
// ****************************************
// FOOTER MAILCHIMP FORM

var footerForm = $(".footer-list__signup").find("form:first");

footerForm.on("submit", function (event) {
	event.preventDefault();

	var formData = new FormData(footerForm[0]);

	$.ajax({
		beforeSend: function(){
			$("[data-signup-failure]").text('').hide();
		},
		contentType: false,
		processData: false,
		method: "POST",
		url: "/",
		dataType: "json",
		data: formData,
	}).done(function (data) {
		console.log('success', data);
		$(".footer-list__signup").addClass("footer-list__signup--success");
	}).fail(function (jqXHR) {
		const data = jqXHR.responseJSON;
		$("[data-footer-signup-failure]").text(data.message).show();
	});
});

// ****************************************
// ****************************************
// SIGNUP PAGE MAILCHIMP FORM

var signupPageForm = $(".signup-page__form").find("form");

signupPageForm.on('submit', function (event) {
    event.preventDefault();

	var formData = new FormData(signupPageForm[0]);

	$.ajax({
		contentType: false,
		processData: false,
		method: "POST",
		url: "/",
		dataType: "json",
		data: formData,
	}).done(function () {
		$(".signup-page").addClass("signup-page--success");
	}).fail(function (jqXHR) {
		const data = jqXHR.responseJSON;
		$("[data-mailchimp-signup-failure]").text(data.message).show();
	});
});

// ****************************************
// ****************************************
// CHECKOUT

var addressFieldsEmpty = function($container) {
	var fieldsEmpty = false;
	$container.find('input[required]').each(function() {
		if($(this).val() === '') {
			fieldsEmpty = true;
			return;
		}
	}); 

	return fieldsEmpty;
};

$('#js-delivery-form').on('submit', function(e) {
	var $shippingAddressFields = $('#shipping-manual-address');
	var $errorContainer = $('#shipping-address-search-error');

	console.log($shippingAddressFields);

	if($shippingAddressFields.hasClass('closed') && addressFieldsEmpty($shippingAddressFields)) {
		e.preventDefault();

		$errorContainer.append('<div class="form__row"><p class="checkout__error">Please use the address search or enter an address manually.</p></div>');
		return false;
	}

	$errorContainer.empty();
	return true;
});

$(".js-payment-gateway-selector").on("change", function () {
	$("#js-checkout-loading").addClass("show");
	$(this).parents("form:first").submit();
});

// ****************************************
// ****************************************
// SAMPLE - ADD TO CART
// ****************************************
// ****************************************

$("#js-sample-order-form").on("submit", function (e) {
	e.preventDefault();

	var form = $(this);

	$.ajax({
		method: "POST",
		url: "/",
		dataType: "json",
		data: form.serializeArray(),
		cache: false,
		dataType: "json",
	}).done(function (data) {
		addToCartGAEvent(form);
		window.location.reload();
	});

	return false;
});


$(document).ready(function() {
	inViewportTargets();
});

$(window).scroll(function() {
	inViewportTargets();
	// stickyHeader();
});